/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type { ICToken, ICTokenInterface } from "../ICToken";

const _abi = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "mintAmountInUnderlying",
        type: "uint256",
      },
    ],
    name: "mint",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "redeemTokensInCtokens",
        type: "uint256",
      },
    ],
    name: "redeem",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
];

export class ICToken__factory {
  static readonly abi = _abi;
  static createInterface(): ICTokenInterface {
    return new utils.Interface(_abi) as ICTokenInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ICToken {
    return new Contract(address, _abi, signerOrProvider) as ICToken;
  }
}
